const React = require('react');
const isEqual = require('mn-utils/isEqual');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const handleProviderProvider = require('mn-utils/changeProviderProviderSimple');
const {
  apiV2BuyerAMLPreferenceSet,
  apiV2BuyerAMLPreferenceGet,
} = require('../../../../../../../api/merchant/buyerAmlPreference');
const numberHandle = require('../../../../../../../utils/numberHandle');
const withState = require('../../../../../../../utils/withState');
const {
  openPopupInfo,
} = require('../../../../../../../emitters/popup');
const WrapperWithLoading = require('../../../../../../dumb/WrapperWithLoading/B');
const Caption = require('../../../../../../dumb/Caption/C');
const TextFieldBase = require('../../../../../../dumb/TextField/Base');
const Button = require('../../../../../../dumb/Button/Accept');
const Switch = require('../../../../../../dumb/Switch/D');


const DEFAULT_PURCHASE_AMOUNT = 15000;
const MINIMUM_PURCHASE_AMOUNT = 1500;


module.exports = withState((setState, self, onMount) => {
  function setStateOfCurrent(stateOfCurrent) {
    setState({
      stateOfCurrent: {
        ...self.state.stateOfCurrent,
        ...stateOfCurrent,
      },
    });
  }

  const changeProvider = changeProviderProvider(setStateOfCurrent);
  const handleProvider = handleProviderProvider(setStateOfCurrent);

  const amountHandle = ((amount) => {
    if (amount > DEFAULT_PURCHASE_AMOUNT) {
      amount = DEFAULT_PURCHASE_AMOUNT;
    }
    return numberHandle(amount);
  });
  const handleChangePurchaseAmount = changeProvider('amount', 0, amountHandle);
  const handleChangePreferenceIsEnabled = handleProvider('preferenceEnabled');

  const stateOfLast = {
    amount: '' + DEFAULT_PURCHASE_AMOUNT,
    preferenceEnabled: false,
  };

  self.state = {
    loading: true,
    clicked: false,
    stateOfLast,
    stateOfCurrent: stateOfLast,
  };

  onMount(() => {
    apiV2BuyerAMLPreferenceGet().finally((error, response) => {
      response = response || {};

      const stateOfCurrent = {
        amount: '' + (response.widget_threshold || ''),
        preferenceEnabled: response.preference_enabled || false,
      };

      setState({
        loading: false,
        stateOfLast: stateOfCurrent,
        stateOfCurrent: stateOfCurrent,
      });
    });
  });


  return (state, props) => {
    const {
      stateOfLast,
      stateOfCurrent,
    } = state;
    const {
      preferenceEnabled,
      amount,
    } = stateOfCurrent;

    const amountNumber = amount ? parseInt(amount) : 0;
    let helperTextAmount = 'Obligatory field';
    let invalidAmount = !amount;
    if (preferenceEnabled) {
      if (amountNumber < MINIMUM_PURCHASE_AMOUNT) {
        invalidAmount = true;
        helperTextAmount = `The amount can not be less than ${MINIMUM_PURCHASE_AMOUNT} EUR`;
      } else if (amountNumber > DEFAULT_PURCHASE_AMOUNT) {
        invalidAmount = true;
        helperTextAmount = `The amount can not be greater than ${DEFAULT_PURCHASE_AMOUNT} EUR`;
      }
    }

    const changed = !isEqual(stateOfLast, stateOfCurrent);

    const disabled = invalidAmount || !changed;


    return (
      <WrapperWithLoading
        className={'wmin270 wmax1000 ' + (props.className || '')}
        loading={state.loading}
      >
        <div className="layoutRow fhaB fvaC">
          <Caption>KYC / AML Preference</Caption>
        </div>

        <div className="mt26 cfx mh-28 (w1/2|ph28|w@m|lt)>1">
          <div>
            <div className="f12 fw4 lh17 mt-2">
              The Buyer will be automatically verified against the AMLD5 regulations
              for purchases above 15.000 EUR or the local currency equivalent.
            </div>
          </div>
          <div className="mt30@m">
            <div className="f12 fw4 lh17">
              Set a minimum purchase amount for Buyer KYC / AML verification:
            </div>
            <div className="layoutRow fhaB fvaC mt30">
              <Switch
                label={preferenceEnabled ? 'Above' : 'No'}
                className="mr15"
                checked={preferenceEnabled}
                onChange={handleChangePreferenceIsEnabled}
              />
              <div className="layoutRow fhaS fvaC">
                <TextFieldBase
                  className="w95"
                  value={amount}
                  disabled={!preferenceEnabled}
                  onChange={handleChangePurchaseAmount}
                  error={invalidAmount}
                  helperText={helperTextAmount}
                  max={1600}
                />
                <div className="ml12 f12 lh18 usN lts0em fw7">EUR</div>
              </div>
            </div>
          </div>
        </div>
        <Button
          className="mt30"
          disabled={disabled}
          onClick={() => {
            setState({
              loading: true,
            });
            apiV2BuyerAMLPreferenceSet({
              preference_enabled: preferenceEnabled,
              ...(preferenceEnabled
                ? {amount: Math.max(MINIMUM_PURCHASE_AMOUNT, amountNumber)}
                : {}
              ),
            }).finally((error) => {
              setState({
                loading: false,
                stateOfLast: error ? stateOfLast : stateOfCurrent,
              });
              error || openPopupInfo([
                'Settings have been changed',
              ]);
            });
          }}
        >Save Settings</Button>
      </WrapperWithLoading>
    );
  };
});
